import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LOADING_CONTEXT, LoadingService } from '@ps/core-overlay';

export function loadingInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const _loadingService = inject(LoadingService);

  const scope = req.context.get(LOADING_CONTEXT);
  if (!scope || scope === 'none') {
    return next(req);
  }

  const loadingId = _loadingService.dispatch(scope);

  return next(req).pipe(finalize(() => _loadingService.stop(scope, loadingId)));
}
